import type { SupportEndReason, SupportScope, SupportStatus } from '@garage/shared';

/** Libellés de l'accès support (vague 5), partagés par le garage et la console. */

export const SUPPORT_STATUS_LABELS: Record<SupportStatus, string> = {
  pending: 'En attente',
  granted: 'Accordé',
  refused: 'Refusé',
  cancelled: 'Annulé',
  expired: 'Échu',
  revoked: 'Retiré',
  ended: 'Rendu',
};

export const SUPPORT_END_LABELS: Record<SupportEndReason, string> = {
  expired: 'échéance atteinte',
  revoked: 'retiré par le garage',
  ended: 'rendu par le support',
};

export const SCOPE_LABELS: Record<SupportScope, string> = {
  read_only: 'lecture seule',
  full: 'accès complet',
};

/** Durée lisible : 60 → « 1 h », 1440 → « 24 h », 10 080 → « 7 jours ». */
export function durationLabel(minutes: number): string {
  if (minutes % 1440 === 0 && minutes / 1440 >= 7) return `${minutes / 1440} jours`;
  if (minutes % 60 === 0) return `${minutes / 60} h`;
  return `${minutes} min`;
}

export function accessSummary(scope: SupportScope, amountsVisible: boolean): string {
  return `${SCOPE_LABELS[scope]}, montants ${amountsVisible ? 'visibles' : 'masqués'}`;
}

const DATE_TIME = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
const TIME = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });

/** « jusqu'à 14:30 » le jour même, sinon « jusqu'au 3 octobre à 14:30 ». */
export function untilLabel(iso: string, prefixDay = 'jusqu’au', now = new Date()): string {
  const d = new Date(iso);
  if (d.toDateString() === now.toDateString()) return `jusqu’à ${TIME.format(d)}`;
  return `${prefixDay} ${DATE_TIME.format(d).replace(/^1 /, '1er ')}`;
}

/**
 * Nom de la plateforme pour « Le support de … » : face garage (`public.platform.productNamePro`,
 * configuration du serveur) ; inconnu ou en chargement : « la plateforme ».
 */
export function platformLabel(productNamePro: string | null | undefined): string {
  return productNamePro?.trim() || 'la plateforme';
}
